export default "__VITE_ASSET__NlJQSHvG__"